import React from 'react'
import { inject, observer } from 'mobx-react'

import Select from '../../generic/Select'
import { Box } from '../../generic/Box'
import Title from '../../generic/Title'

const CompanyList = inject('companiesStore', 'userStore')(observer(props => {
  const { formStore, companiesStore, userStore, permission } = props
  const options = userStore.checkPermission(permission) ? (
    companiesStore.state.companies.map(data => {
      return {value: data.id, name: data.name}
    })
  ) : (
    userStore.state.companies.map(data => {
      return {value: data.id, name: data.name}
    })
  )
  return (
    <Box>
      <Title>Empresas</Title>
      <Select
        store={formStore}
        fieldData={{
          name: 'company',
          id: 'nfe-company',
          selectedValue: formStore.state.company,
          options: options,
          onChange: (event) => {
            formStore.setCompany(event.target.value)
          }
        }}
      />
    </Box>
  )
}))

export default CompanyList



// WEBPACK FOOTER //
// ./src/components/dashboard/products/CompanyList.js